import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state';
import { EHeatingType } from '../../../../json_query';
import { changeHeating } from '../../../state/advanced/heating';
import { InlineParam, Row } from '../markup';

interface IHeatingProps {
  heatings: EHeatingType[];
  onHeatingChange(heatingType: EHeatingType, value: boolean): void;
}

const isHeatingExists = (existingHeatingTypes: EHeatingType[], parking: EHeatingType): boolean => {
  return existingHeatingTypes.indexOf(parking) > -1;
};

const Heating: React.StatelessComponent<IHeatingProps> = props => (
  <Row title="Отопление">
    {[
      { name: 'Центральное газовое', type: EHeatingType.Gas },
      { name: 'Угольное', type: EHeatingType.Coal },
      { name: 'Печь', type: EHeatingType.Furnace },
      { name: 'Камин', type: EHeatingType.Fireplace },
      { name: 'Электрическое', type: EHeatingType.Electric },
      { name: 'Автономное газовое', type: EHeatingType.AutonomousGas },
      { name: 'Дизельное', type: EHeatingType.Diesel },
      { name: 'Твердотопливный котел', type: EHeatingType.SolidFuelBoiler },
      { name: 'Не отапливается', type: EHeatingType.None },
    ].map((heatingProps, i) => (
      <InlineParam key={heatingProps.name}>
        <ButtonCheckbox
          onValueChange={value => props.onHeatingChange(heatingProps.type, value)}
          value={isHeatingExists(props.heatings, heatingProps.type)}
        >
          {heatingProps.name}
        </ButtonCheckbox>
      </InlineParam>
    ))}
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    heatings: (state.filters.jsonQuery.heating_source_type && state.filters.jsonQuery.heating_source_type.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onHeatingChange: (heatingType: EHeatingType, value: boolean) => {
      dispatch(changeHeating(heatingType, value));
    },
  }),
)(Heating);
